import * as PropTypes from "prop-types";
import * as React from "react";

import Result from "src/models/result";

import Body from "./Body";

import {
  Avatar,
  Chip,
  Divider,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Typography
} from "@material-ui/core";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import { Theme, WithStyles, withStyles } from "@material-ui/core/styles";

import DateIcon from "@material-ui/icons/CalendarToday";
import FileIcon from "@material-ui/icons/Code";
import HostIcon from "@material-ui/icons/Computer";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const styles = (theme: Theme) => ({
  chip: {
    margin: theme.spacing.unit
  },
  large_col: {
    flexBasis: "75%",
    maxHeight: "20em"
  },
  root: {
    display: "flex",
    justifyContent: "center"
  },
  small_col: {
    flexBasis: "25%"
  }
});

export interface IProps extends WithStyles<typeof styles> {
  result: Result;
}

class Item extends React.Component<IProps, any> {
  public constructor(props: IProps) {
    super(props);

    this.getChips = this.getChips.bind(this);
  }

  public render() {
    const { classes } = this.props;

    return (
      <ExpansionPanel>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <div className={classes.large_col}>
            <Typography>{this.props.result.Document.URI}</Typography>
          </div>
          <div className={classes.small_col}>
            <Chip
              icon={<FileIcon />}
              label={this.props.result.Document.Type}
              className={classes.chip}
            />
          </div>
        </ExpansionPanelSummary>
        <Divider />
        <ExpansionPanelDetails>
          <div className={classes.large_col}>
            <Body doc={this.props.result.Document} />
          </div>
          <div className={classes.small_col}>{this.getChips()}</div>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  }

  private getChips(): any {
    const { classes } = this.props;

    const doc = this.props.result.Document;

    const chips = [
      <Chip
        key={"dateChip"}
        icon={<DateIcon />}
        label={doc.Date.toLocaleDateString()}
        className={classes.chip}
      />
    ];

    if (doc.hasAttribute("hostname")) {
      chips.push(
        <Chip
          key={"hostChip"}
          label={doc.getAttribute("hostname")}
          icon={<HostIcon />}
          className={classes.chip}
        />
      );
    }

    if (doc.hasAttribute("extension")) {
      chips.push(
        <Chip
          key={"extChip"}
          avatar={<Avatar>ex</Avatar>}
          label={"." + doc.getAttribute("extension")}
          className={classes.chip}
        />
      );
    }

    return chips;
  }
}
(Item as React.ComponentClass<IProps>).propTypes = {
  classes: PropTypes.object.isRequired
} as any;

export default withStyles(styles)(Item);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Item.tsx